module.exports = __webpack_public_path__ + "static/img/icon2.d3424296.png";